// React Imports
import * as React from 'react';
import {useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Divider from "@mui/material/Divider";
import {Avatar, Tooltip} from "@mui/material";
import Stack from "@mui/material/Stack";

// App Imports


// main function
export default function ContractStatsPanel({onCsList, onCsfList, onCdpList, onCdpvList, onCdpvfList, onVocabularyList, onMarketList}) {


    // *********************** BEGIN STORE ********************************

    const selectorContractId = useSelector((state) => state.contractSlc.value.id);
    const selectorContractName = useSelector((state) => state.contractSlc.value.name);

    const selectorCsCount = useSelector((state) => state.contractSlc.value.csCount);
    const selectorCsfCount = useSelector((state) => state.contractSlc.value.csfCount);
    const selectorCdpCount = useSelector((state) => state.contractSlc.value.cdpCount);
    const selectorCdpvCount = useSelector((state) => state.contractSlc.value.cdpvCount);
    const selectorCdpvfCount = useSelector((state) => state.contractSlc.value.cdpvfCount);
    const selectorVocabCount = useSelector((state) => state.contractSlc.value.vocabCount);
    const selectorMarketCount = useSelector((state) => state.contractSlc.value.marketCount);

    // const csDigitCount = useSelector((state) => state.contractSlc.value.csCount).toString().length;
    // const csfDigitCount = useSelector((state) => state.contractSlc.value.csfCount).toString().length;
    // const cdpDigitCount = useSelector((state) => state.contractSlc.value.cdpCount).toString().length;
    // const cdpvDigitCount = useSelector((state) => state.contractSlc.value.cdpvCount).toString().length;
    // const cdpvfDigitCount = useSelector((state) => state.contractSlc.value.cdpvfCount).toString().length;
    // const vocabDigitCount = useSelector((state) => state.contractSlc.value.vocabCount).toString().length;
    // const marketDigitCount = useSelector((state) => state.contractSlc.value.marketCount).toString().length;
    //
    // const csWidth = (useSelector((state) => state.contractSlc.value.csCount).toString().length - 1) * 12 + 22;
    // const csfWidth = (useSelector((state) => state.contractSlc.value.csfCount).toString().length - 1) * 12 + 22;
    // const cdpWidth = (useSelector((state) => state.contractSlc.value.cdpCount).toString().length - 1) * 12 + 22;
    // const cdpvWidth = (useSelector((state) => state.contractSlc.value.cdpvCount).toString().length - 1) * 12 + 22;
    // const cdpvfWidth = (useSelector((state) => state.contractSlc.value.cdpvfCount).toString().length - 1) * 12 + 22;
    // const vocabWidth = (useSelector((state) => state.contractSlc.value.vocabCount).toString().length - 1) * 12 + 22;
    // const marketWidth = (useSelector((state) => state.contractSlc.value.marketCount).toString().length - 1) * 12 + 22;

    const csWidth = (Math.max(String(useSelector(s => s.contractSlc?.value?.csCount ?? 0)).length - 1, 0) * 12) + 22;
    const csfWidth = (Math.max(String(useSelector(s => s.contractSlc?.value?.csfCount ?? 0)).length - 1, 0) * 12) + 22;
    const cdpWidth = (Math.max(String(useSelector(s => s.contractSlc?.value?.cdpCount ?? 0)).length - 1, 0) * 12) + 22;
    const cdpvWidth = (Math.max(String(useSelector(s => s.contractSlc?.value?.cdpvCount ?? 0)).length - 1, 0) * 12) + 22;
    const cdpvfWidth = (Math.max(String(useSelector(s => s.contractSlc?.value?.cdpvfCount ?? 0)).length - 1, 0) * 12) + 22;
    const vocabWidth = (Math.max(String(useSelector(s => s.contractSlc?.value?.vocabCount ?? 0)).length - 1, 0) * 12) + 22;
    const marketWidth = (Math.max(String(useSelector(s => s.contractSlc?.value?.marketCount ?? 0)).length - 1, 0) * 12) + 22;

    // ********************** END STORE ********************************


    // ****************** BEGIN RETURN ****************************

    return (
        <Box  sx={{ ml: 10, width:900}} >
            <Stack direction="row" spacing={2}
                   justifyContent="center"    // center the pair
                   alignItems="flex-start"
            >
                <Box
                    sx={{
                        pt: 7,
                        pl: 20,
                        px: 20,
                        // width: '100%',
                        width: '100%',
                    }}
                >
                    <Stack spacing={2}>  {/* vertical spacing between rows */}

                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <h3>Sections :</h3>
                            {selectorCsCount > 0 && (
                                <Tooltip title="Count of contract sections."
                                         onClick={() => onCsList(selectorContractId, selectorContractName)}>
                                    <Avatar
                                        variant="rounded"
                                        sx={{
                                            height: 25,
                                            width: csWidth,
                                            fontSize: 20,
                                            bgcolor: "rgb(30,144,255)",
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {selectorCsCount}
                                    </Avatar>
                                </Tooltip>
                            )}
                        </Stack>

                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <h3>Section Filters :</h3>
                            {selectorCsfCount > 0 && (
                                <Tooltip title="Count of contract section filters."
                                         onClick={() => onCsfList(selectorContractId, selectorContractName)}>
                                    <Avatar
                                        variant="rounded"
                                        sx={{
                                            height: 25,
                                            width: csfWidth,
                                            fontSize: 20,
                                            bgcolor: "rgb(30,144,255)",
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {selectorCsfCount}
                                    </Avatar>
                                </Tooltip>
                            )}
                        </Stack>

                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <h3>Data Points :</h3>
                            {selectorCdpCount > 0 && (
                                <Tooltip title="Count of contract data points."
                                         onClick={() => onCdpList(selectorContractId, selectorContractName)}>
                                    <Avatar
                                        variant="rounded"
                                        sx={{
                                            height: 25,
                                            width: cdpWidth,
                                            fontSize: 20,
                                            bgcolor: "rgb(30,144,255)",
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {selectorCdpCount}
                                    </Avatar>
                                </Tooltip>
                            )}
                        </Stack>

                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <h3>Values :</h3>
                            {selectorCdpvCount > 0 && (
                                <Tooltip title="Count of contract data point values."
                                         onClick={() => onCdpvList(selectorContractId, selectorContractName)}>
                                    <Avatar
                                        variant="rounded"
                                        sx={{
                                            height: 25,
                                            width: cdpvWidth,
                                            fontSize: 20,
                                            bgcolor: "rgb(30,144,255)",
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {selectorCdpvCount}
                                    </Avatar>
                                </Tooltip>
                            )}
                        </Stack>

                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <h3>Value Filters :</h3>
                            {selectorCdpvfCount > 0 && (
                                <Tooltip title="Count of contract data point value filters."
                                         onClick={() => onCdpvfList(selectorContractId, selectorContractName)}>
                                    <Avatar
                                        variant="rounded"
                                        sx={{
                                            height: 25,
                                            width: cdpvfWidth,
                                            fontSize: 20,
                                            bgcolor: "rgb(30,144,255)",
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {selectorCdpvfCount}
                                    </Avatar>
                                </Tooltip>
                            )}
                        </Stack>

                    </Stack>
                </Box>
<Box sx={{ width: 80 }}/>
                <Stack spacing={2} sx={{ pt: 7, mr: 30, px: 2, width: '80%' }}>

                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <h3>Vocabulary :</h3>
                        {selectorVocabCount > 0 && (
                            <Tooltip title="Count of distinct data points."
                                     onClick={() => onVocabularyList(selectorContractId, selectorContractName)}
                            >
                                <Avatar
                                    variant="rounded"
                                    sx={{
                                        height: 25,
                                        width: vocabWidth,
                                        fontSize: 20,
                                        bgcolor: "rgb(30,144,255)",
                                        cursor: 'pointer',
                                    }}
                                >
                                    {selectorVocabCount}
                                </Avatar>
                            </Tooltip>
                        )}
                    </Stack>

                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <h3>Markets :</h3>
                        {selectorMarketCount > 0 && (
                            <Tooltip title="Count of distinct reuse markets."
                                     onClick={() => onMarketList(selectorContractId, selectorContractName)}
                            >
                                <Avatar
                                    variant="rounded"
                                    sx={{
                                        height: 25,
                                        width: marketWidth,
                                        fontSize: 20,
                                        bgcolor: "rgb(30,144,255)",
                                        cursor: 'pointer',
                                    }}
                                >
                                    {selectorMarketCount}
                                </Avatar>
                            </Tooltip>
                        )}
                    </Stack>

                </Stack>


            </Stack>
        </Box>
    )

    // ****************** END RETURN ****************************

}
// {/*<Stack direction="row" spacing={2}>*/}
// {/*    <h3>Vocabulary : </h3>*/}
// {/*    {selectorVocabCount > 0 && (*/}
// {/*    <Tooltip title={"Count of distinct data points."}*/}
// {/*             onClick= {() => onVocabularyList(selectorContractId, selectorContractName)}*/}
// {/*    >*/}
// {/*        <Avatar variant="rounded" sx={{*/}
// {/*            height: 25,*/}
// {/*            width: vocabWidth,*/}
// {/*            fontSize: 20,*/}
// {/*            bgcolor: "rgb(30,144,255)"*/}
// {/*        }}*/}
// {/*                style={{cursor:'pointer'}}*/}
// {/*        >*/}
// {/*            {selectorVocabCount}*/}
// {/*        </Avatar>*/}
// {/*    </Tooltip>)}*/}
// {/*</Stack>*/}
//
// {/*<br/>*/}
//
// {/*<Stack direction="row" spacing={2}>*/}
// {/*    <h3>Markets : </h3>*/}
// {/*    {selectorMarketCount > 0 && (*/}
// {/*    <Tooltip title={"Count of distinct reuse markets."}*/}
// {/*             onClick= {() => onMarketList(selectorContractId, selectorContractName)}*/}
// {/*    >*/}
// {/*        <Avatar variant="rounded" sx={{*/}
// {/*            height: 25,*/}
// {/*            width: marketWidth,*/}
// {/*            fontSize: 20,*/}
// {/*            bgcolor: "rgb(30,144,255)"*/}
// {/*        }}*/}
// {/*                style={{cursor:'pointer'}}*/}
// {/*        >*/}
// {/*            {selectorMarketCount}*/}
// {/*        </Avatar>*/}
// {/*    </Tooltip>)}*/}
// {/*</Stack>*/}